import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Modal } from "../Modal";
import { SusanMac } from "../people/SusanMac";
import { AmyLuk } from "../people/AmyLuk";
import { FourPointFour } from "../people/4point4";
import { AmandaGaddy } from "../people/AmandaGaddy";
import { BritishAirways } from "../people/BritishAirways";
import { EinsteinMoomjy } from "../people/EinsteinMoomjy";
import { CaliforniaBurrito } from "../people/CaliforniaBurrito";
import { PartnershipOfFaith } from "../people/PartnershipOfFaith";
import { JonathonBurgess } from "../people/JonathonBurgess";
import { Nascar } from "../people/Nascar";
import { NflProperties } from "../people/NflProperties";
import { PatrickMacmurchy } from "../people/PatrickMacmurchy";
import { ShannonDunn } from "../people/ShannonDunn";
import { StephLotze } from "../people/StephLotze";
import { Executioners } from "./Executioners";
import { BackButton } from "../NavButton";

const PEOPLE_MODALS = {
  SusanMac: SusanMac,
  CaliforniaBurrito: CaliforniaBurrito,
  AmyLuk: AmyLuk,
  EinsteinMoomjy: EinsteinMoomjy,
  AmandaGaddy: AmandaGaddy,
  PartnershipOfFaith: PartnershipOfFaith,
  ShannonDunn: ShannonDunn,
  BritishAirways: BritishAirways,
  PatrickMacmurchy: PatrickMacmurchy,
  NflProperties: NflProperties,
  StephLotze: StephLotze,
  FourPointFour: FourPointFour,
  JonathonBurgess: JonathonBurgess,
  Nascar: Nascar,
};

const PEOPLE_MODALS_ARRAY = [
  SusanMac,
  CaliforniaBurrito,
  AmyLuk,
  EinsteinMoomjy,
  AmandaGaddy,
  PartnershipOfFaith,
  ShannonDunn,
  BritishAirways,
  PatrickMacmurchy,
  NflProperties,
  StephLotze,
  FourPointFour,
  JonathonBurgess,
  Nascar,
];

const modalTitles = {
  SusanMac: "Susan Macmurchy",
  CaliforniaBurrito: "California Burrito",
  AmyLuk: "Amy Luk",
  EinsteinMoomjy: "Einstein Moomjy",
  AmandaGaddy: "Amanda Gaddy",
  PartnershipOfFaith: "Partnership of Faith",
  ShannonDunn: "Shannon Dunn",
  BritishAirways: "British Airways",
  PatrickMacmurchy: "Patrick Macmurchy",
  NflProperties: "NFL Properties",
  StephLotze: "Steph Lotze",
  FourPointFour: "FourPointFour",
  JonathonBurgess: "Jonathon Burgess",
  Nascar: "Nascar",
};

export const People = ({ active, getSlideNumber, updateActiveSlide }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const PreviousModal = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + PEOPLE_MODALS_ARRAY.length) %
        PEOPLE_MODALS_ARRAY.length
    );
  };

  const NextModal = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex + 1) % PEOPLE_MODALS_ARRAY.length
    );
  };

  const CurrentModal = PEOPLE_MODALS_ARRAY[currentIndex];
  const currentPerson = Object.keys(PEOPLE_MODALS)[currentIndex];

  return (
    <div id="people" className={`${active ? "active " : ""}item`}>
      {createPortal(
        <Modal
          title={modalTitles[currentPerson]}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onPrev={PreviousModal}
          onNext={NextModal}
        >
          <CurrentModal />
        </Modal>,
        document.body
      )}

      <div className="fill" style={{ backgroundColor: "white" }}>
        <div className="container">
          <div className="row">
            {[
              { img: "url('/images/IMG_4883_CROP.jpg')" },
              { img: "url('/images/executioners/burrito1.jpg')" },
              { img: "url('/images/executioners/amylukken.jpg')" },
              { img: "url('/images/executioners/moomjy.jpg')" },
              { img: "url('/images/executioners/amandagaddy.jpg')", posX: "-8px" },
              { img: "url('/images/executioners/expectmiracles.jpg')" },
              { img: "url('/images/executioners/shannondunn-modal.png')" },
              { img: "url('/images/executioners/britishairway.jpg')" },
              { img: "url('/images/executioners/pmacmurchy.jpg')" },
              { img: "url('/images/executioners/proline.jpg')" },
              { img: "url('/images/executioners/stephlotze.png')" },
              { img: "url('/images/executioners/4point4main.png')" },
              { img: "url('/images/executioners/jonathanburgess.jpg')" },
              { img: "url('/images/executioners/nascar.png')" },
            ].map(({ img, posX }, i) => (
              <div
                key={i}
                className="transparent-hoverPointer executionerGrid"
                onClick={() => openModal(i)}
                style={{
                  backgroundImage: img,
                  ...(posX ? { backgroundPositionX: posX } : {}),
                }}
              />
            ))}
          </div>
        </div>
        <BackButton onClick={() => updateActiveSlide(getSlideNumber(Executioners))} />
      </div>
    </div>
  );
};

People.slideName = "People";
People.pathname = "/people";

export default People;
